import TabsSnippet from 'content/snippets/main/mdx-tabs';
import RedefineSnippet from 'content/snippets/main/mdx-redefine';
import ImportSnippet from 'content/snippets/main/mdx-import';
import { Tabs } from 'antd';
import React from 'react';
import { MDXTag } from '@mdx-js/tag';
export default {
  TabsSnippet,
  RedefineSnippet,
  ImportSnippet,
  Tabs,
  React,
  MDXTag
};